<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>通知类型：</label>
                <el-select v-model="search_Obj.f_notice_type" clearable placeholder="请选择" @keyup.enter.native="doSearch" style="width: 200px">
                    <el-option v-for="item in enuObj('notice_type')" :key="'notice_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>邮箱：</label>
                <el-input v-model="search_Obj.f_email" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>注册时间：</label>
                <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="dateRangeSet"
                    style="width:320px">
                </el-date-picker>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="notice_type" label="通知类型" sortable="custom" width="140">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.notice_type, "notice_type") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="email" label="email" sortable="custom" width="200"></el-table-column>
                <el-table-column prop="car_id" label="CarId" sortable="custom" width="170"></el-table-column>
                <el-table-column prop="first" label="标题" sortable="custom"></el-table-column>
                <el-table-column prop="send_time" label="发生时间" sortable="custom" width="180"></el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看微信通知"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'noticeList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '微信通知',
            menu_id: 2400,
            list_url: "/api/admin/notice/list",
            search_Obj: {
                f_email: '',
                f_notice_type: '',
                f_send_time_s_date: '',
                f_send_time_e_date: '',
            },
            del_Obj:{
                url:'/api/admin/notice/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['notice_type'],
            dateRange: '',
        };
    },
    methods: {
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_send_time_s_date = val[0]
                this.search_Obj.f_send_time_e_date = val[1]
            }else{
                this.search_Obj.f_send_time_s_date = ''
                this.search_Obj.f_send_time_e_date = ''
            }
        },
    }
};
</script>